import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  background: ${({ theme }) => `radial-gradient(
    280px 140px at 110% 90%,
    ${theme.colors.secondary.lighter} -10%,
    ${theme.colors.secondary.main})`};
  width: 100%;
  padding: 1.6rem 1.2rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0 1rem;
  align-items: center;
  position: relative;
  border-radius: 0.5rem;
  border: ${({ theme }) => `1px solid ${theme.colors.secondary.lighter}`};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 2.4rem 4.6rem;
    background: ${({ theme }) => `radial-gradient(
      500px 180px at 110% 90%,
      ${theme.colors.secondary.lighter},
      ${theme.colors.secondary.main})`};
  }
`;

export const StyledCrownImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;

  width: 8.215rem;
  transform: translate(21px, -33px) rotate(22.25deg);

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 10.553rem;
    transform: translate(26px, -41px) rotate(22.25deg);
  }
`;

export const StyledArrowImage = styled.img`
  width: 5.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 8.654rem;
  }
`;

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const StyledBlockTitle = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  text-align: center;
`;

export const StyledBlockContent = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  text-align: center;
  span {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    color: ${secondaryColors.grey[500]};
  }

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0 1rem;
`;
